<template>
  <div class="check-container">
    <a-layout>
      <a-page-header
        class="check-group-name"
        sub-title=""
        @back="() => $router.go(-1)"
      >
        <template slot="title">
          <div class="title-left">
            <span class="title-h1">{{ studentName }}</span>
            <span>{{ lessonName }}</span>
            <i class="link-type">{{ linkTypeName }}</i>
          </div>
          <div class="title-right">
            <span class="title-h2">{{ groupName }}</span>
            <span v-if="userId">学生ID: {{ userId }}</span>
            <span v-if="optTime">{{ optTime | formatDate }}</span>
          </div>
        </template>
      </a-page-header>
      <a-layout>
        <a-layout-content class="canvas-wrap">
          <a-spin :spinning="spinning" tip="加载中...">
            <div class="canvasbox" ref="canvasbox">
              <canvas
                id="canvas"
                width="1280"
                height="720"
              />
            </div>
            <a-button
              type="link"
              :disabled="index === 1"
              @click="handlePrev"
              class="page-btn page-prev"
            >
              <svg-icon icon="arrawLeft" />
            </a-button>
            <a-button
              type="link"
              :disabled="nextbtnStatus || isLast"
              @click="handleNext"
              class="page-btn page-next"
            >
              <svg-icon icon="arrawRight" />
            </a-button>
          </a-spin>
          <div class="operatebox">
            <div class="answer-btn">
              <!-- 查看答案 -->
              <a-button
                v-if="isShowAnswer"
                @click="showAnswer"
                type="link"
              >
                答案
              </a-button>
            </div>
            <div class="operate-center">
              <div class="center-left" />
              <!-- 批改工具栏 -->
              <ul class="operate-tool">
                <li @click="handleRight">
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>正确</span>
                    </template>
                    <i class="operate-icon" :style="{ backgroundImage: 'url('+RightBrushDataUrl+')'}" />
                  </a-tooltip>
                </li>
                <li @click="handleWrong">
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>错误</span>
                    </template>
                    <i class="operate-icon" :style="{ backgroundImage: 'url('+WrongBrushDataUrl+')'}" />
                  </a-tooltip>
                </li>
                <li><span class="line" /></li>
                <li @click="handleModify" class="edit-tool">
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>修改批注</span>
                    </template>
                    <i class="iconfont-new icon-edit-copy icon-tool" />
                  </a-tooltip>
                </li>
                <li class="edit-tool">
                  <a-popconfirm placement="topRight" ok-text="确定" cancel-text="取消" @confirm="confirmClear">
                    <template slot="title">
                      <p>确定将所有批改清空吗？</p>
                    </template>
                    <a-tooltip placement="top">
                      <template slot="title">
                        <span>清屏</span>
                      </template>
                      <i class="iconfont-new icon-clear-copy icon-tool" />
                    </a-tooltip>
                  </a-popconfirm>
                </li>
              </ul>
              <div class="center-right" />
            </div>
            <div class="operate-right">
              <!-- 放大、缩小 -->
              <ul class="operate-tool-right">
                <li @click="zoomOut()">
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>放大</span>
                    </template>
                    <i class="iconfont-new icon-zoomOut-copy icon-tool" />
                  </a-tooltip>
                </li>
                <li @click="zoomIn()">
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>缩小</span>
                    </template>
                    <i class="iconfont-new icon-zoomIn-copy icon-tool" />
                  </a-tooltip>
                </li>
                <li @click="handlexRotate">
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>旋转90度</span>
                    </template>
                    <i class="iconfont-new icon-rotation-copy icon-tool" />
                  </a-tooltip>
                </li>
                <li class="line-wrap">
                  <span class="line" />
                </li>
                <li>
                  <p class="page-num">
                    页数: {{ index }} / {{ imgArr.length }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </a-layout-content>
        <a-layout-sider
          width="292"
          class="info"
        >
          <div class="operate-right-top">
            <a-row
              type="flex"
              justify="start"
              align="middle"
              class="txarea"
            >
              <a-col
                :span="8"
                class="strong comment"
              >
                总评语
              </a-col>
              <a-textarea
                placeholder="请输入评语"
                :rows="4"
                :max-length="200"
                ref="textarea"
                @change="handleTextarea"
              />
              <p class="count">
                {{ countLength }}/{{ totalLength }}
              </p>
            </a-row>
            <div class="audio-wrap">
              <p class="strong audio-title">
                语音点评<span class="audio-tip">
                  <a-icon class="tip-icon" type="exclamation-circle" />
                  最长{{ maxVideoTime / 60 }}分钟</span>
              </p>
              <AudioRecord ref="audioRecord" :max-video-time="maxVideoTime" @startRecord="startRecord" />
            </div>
            <template v-if="isLast">
              <a-row
                type="flex"
                justify="start"
                align="middle"
              >
                <a-col
                  :span="8"
                  class="strong"
                >
                  <span class="required">*</span>批改结果
                </a-col>
              </a-row>
              <div class="operate-result">
                <a-tooltip placement="top" v-for="item in resultArr" :key="item.key">
                  <template slot="title">
                    <span>
                      <p>将获得<em>{{ item.gold }}</em>金币</p>
                    </span>
                  </template>
                  <a-button
                    type="primary"
                    :data-key="item.key"
                    @click="handleAnswerResult(item)"
                    :ghost="teacherOperateType !== item.key"
                  >
                    <i>{{ item.name }}</i>
                  </a-button>
                </a-tooltip>
              </div>
              <!-- 只有选择了批改结果才显示发送提醒 -->
              <a-checkbox class="result-send-checkbox" v-if="teacherOperateType" v-model="sendToFamily" @change="onChange">
                {{ ModalText }}
              </a-checkbox>
            </template>
          </div>
          <div class="send-stu-btn">
            <a-button
              type="danger"
              @click="submitConfirm"
              :loading="confirmLoading"
              :disabled="updateDisable || !isLast"
            >
              {{ submitTxt }}
            </a-button>
          </div>
        </a-layout-sider>
      </a-layout>
      <!-- <a-modal
        title="确认将批改结果发送给学生吗？"
        :visible="visible"
        :confirm-loading="confirmLoading"
        :ok-text="okText"
        cancel-text="取消"
        @ok="postCorrectionData"
        @cancel="handleCancel"
      >
        <a-checkbox v-model="sendToFamily" @change="onChange">
          {{ ModalText }}
        </a-checkbox>
      </a-modal> -->
    </a-layout>
    <!-- 日积月累查看答案 -->
    <TopicDrawer
      v-if="isWorkword"
      :class-type-id="queryParams.classTypeId"
      :lesson-id="queryParams.lessonId"
      :ai-lesson-id="queryParams.aiLessonId"
      ref="answerModal"
    />
    <!-- 融汇贯通答案 -->
    <PicDrawer
      v-if="isFirstExamWord"
      :class-type-id="queryParams.classTypeId"
      :lesson-id="queryParams.lessonId"
      :ai-lesson-id="queryParams.aiLessonId"
      :is-img="true"
      ref="answerModal"
    />
  </div>
</template>
<script>
import '@/static/js/fabric-brush.min.js'
import { loadScript } from '@aixuexi/tol-utils'
import TopicDrawer from '@/components/Answer/TopicDrawer.vue'
import PicDrawer from '@/components/Answer/PicDrawer.vue'
import AudioRecord from '@/components/Audio/AudioRecord.vue'
import { message } from 'ant-design-vue'
import correctLogger from '@/utils/logger/correct.js'
const SDK_URL = 'https://q-fe.aixuexi.com/storage/sdk/js/upload-1.3.0.min.js'

const SUBMIT_TXT = '提交批改'

const RightBrushDataUrl = 'data:image/png;base64,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'
const WrongBrushDataUrl = 'data:image/png;base64,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'

const PAD_WIDTH = 1280
const PAD_HEIGHT = 720

export default {
  name: 'Checktool',
  components: {
    AudioRecord,
    TopicDrawer,
    PicDrawer
  },
  data() {
    return {
      groupName: '',
      lessonName: '',
      panning: false,
      canvas: null,
      imgArr: [],
      brushColor: '#ff0000',
      // 通过改变图片的大小可以改变笔刷的大小
      RightBrushDataUrl,
      WrongBrushDataUrl,
      angle: 0,
      index: 1,
      maxWidth: 1280,
      maxHeight: 720,
      tempData: new Map(),
      imgData: new Map(),
      form: new FormData(),
      countLength: 0,
      totalLength: 200,
      updateDisable: true,
      visible: false,
      isRemind: 0,
      confirmLoading: false,
      studentName: '',
      linkTypeName: '',
      optTime: '',
      linkId: 0,
      userId: 0,
      linkType: '',
      remark: '',
      // 类型: String 4: 打回订正, 5: 过关，6:优秀
      teacherOperateType: 0,
      buttonType: 1,
      originWidth: PAD_WIDTH,
      originHeight: PAD_HEIGHT,
      spinning: false,
      warnTimeOutTimer: null,
      warnSpeed: 3000, // 异常提示延迟处理
      queryParams: {}, // 存储query参数
      nextbtnStatus: false,
      sendToFamily: true,
      // 最长录音时间, 3分钟，单位秒
      maxVideoTime: 3 * 60,
      submitTxt: SUBMIT_TXT,
      resultArr: [
        {
          key: 4,
          name: '打回订正',
          gold: '0'
        },
        {
          key: 5,
          name: '过关',
          gold: '10-15'
        },
        {
          key: 6,
          name: '优秀',
          gold: '20-25'
        }
      ]
    }
  },
  computed: {
    okText() {
      if (this.buttonType == 2) {
        return '确定'
      }
      return '确定，批改下一份'
    },
    isLast() {
      if (this.index === this.imgArr.length) {
        return true
      }
      return false
    },
    // 是否为日积月累
    isWorkword() {
      return Number(this.linkType) === 4
    },
    // 是否为融汇贯通
    isFirstExamWord() {
      return Number(this.linkType) === 5
    },
    // 是否显示查看答案
    isShowAnswer() {
      const { isWorkword, isFirstExamWord } = this
      return isWorkword || isFirstExamWord
    },
    // 提醒家长督促学生
    isSupervise() {
      return this.teacherOperateType === 4
    },
    ModalText() {
      return this.isSupervise ? '提醒家长督促学生' : '提醒家长表扬学生'
    }
  },
  watch: {
    teacherOperateType: {
      immediate: true,
      handler(val) {
        // 只有优秀是默认选中
        this.sendToFamily = val === 6
      }
    },
    confirmLoading(val) {
      if (!val) {
        this.submitTxt = SUBMIT_TXT
      }
    }
  },
  created() {
    if (!window.uploadFile) {
      loadScript(SDK_URL)
    }
    this.query = this.$route.query
  },
  mounted() {
    this.queryParams = this.query
    const { groupName, lessonName, userId, linkType } = this.query
    this.initCheckTool({ groupName, lessonName, userId, linkType }, false)
    // 计时，用于算埋点的批改时间
    this.correctTime = new Date().getTime()
  },
  methods: {
    initCheckTool({ groupName, lessonName, userId, linkType }, isErrForNext) {
      this.maxWidth = window.innerWidth - 495
      this.maxHeight = window.innerHeight - 115
      groupName && (this.groupName = groupName)
      lessonName && (this.lessonName = lessonName)
      linkType && (this.linkType = linkType)
      this.userId = userId
      this.getCorrectionData({ userId }, isErrForNext)
    },
    /**
     * 获取批改列表
     */
    getCorrectionData(opts, isErrForNext) {
      const params = {
        classTypeId: +this.query.classTypeId,
        lessonId: +this.query.lessonId,
        xkhTeacherCourseId: +this.query.xkhTeacherCourseId,
        userId: opts.userId,
        linkType: this.linkType
      }
      // 当前学生不在组内时打开下一份(另一个学生)，不传userID
      if (params.userId === -1) {
        delete params.userId
      }
      this.$service.correction
        .getCorrectionList(params)
        .then(res => {
          this.userId = res.userId
          this.studentName = res.userName
          this.linkTypeName = res.linkTypeName
          this.linkId = res.linkId
          this.optTime = res.optTime
          this.imgArr = res.linkDetailList
          if (res.residueCount == 0) {
            this.buttonType = 2
          }
          if (isErrForNext) {
            this.resetCheckTool(res)
          } else {
            this.initCanvas()
          }
        })
        .catch(() => {})
    },
    /**
     * 重置批改面板
     */
    resetCheckTool(res) {
      this.clearCheck()
      if (res.linkDetailList) {
        this.resetData()
        this.setImage(this.imgArr[this.index - 1].path, true)
      }
    },
    submitConfirm() {
      if (this.confirmLoading) {
        return
      }
      this.confirmLoading = true
      this.postCorrectionData().finally(() => {
        this.confirmLoading = false
      })
    },
    /**
     * 提交批改
     */
    async postCorrectionData() {
      const audioRecordRef = this.$refs.audioRecord
      let audioUrl
      let audioDuration
      // 录音了
      if (audioRecordRef.recordTime) {
        if (audioRecordRef.isRecording) {
          // 正在录音中
          message.error('正在录音中，请先停止录音')
          return
        }
        try {
          this.submitTxt = '录音上传中'
          const record = await audioRecordRef.upload()
          audioUrl = record.url
          audioDuration = record.audioDuration
        } catch (e) {
          message.error('上传录音出错')
          this.confirmLoading = false
          return
        }
      }
      try {
        this.submitTxt = '图片上传中'
        await this.handleSave(this.index, true)
      } catch (e) {
        message.error('上传图片出错')
        this.confirmLoading = false
        return
      }
      this.submitTxt = SUBMIT_TXT
      const classTypeId = +this.query.classTypeId
      const lessonId = +this.query.lessonId
      const xkhTeacherCourseId = +this.query.xkhTeacherCourseId
      const userId = +this.userId
      const { remark, teacherOperateType, isSupervise, isRemind } = this
      const params = {
        classTypeId,
        lessonId,
        xkhTeacherCourseId,
        linkType: +this.linkType,
        userId,
        linkId: this.linkId,
        remark,
        teacherOperateType,
        isRemind,
        detailList: this.formatData(this.imgData),
        buttonType: this.buttonType,
        classCorrectOptType: 1
      }
      if (audioUrl) {
        // 录音 mp3 地址
        params.audioUrl = audioUrl
        // 录音时长
        params.audioDuration = audioDuration
      }
      this.sendToFamily = false
      // 批改结果类型名称
      const operateTypeName = this.getOperateName()
      this.$service.correction
        .postCorrectionList(params)
        .then(res => {
          console.log(res, 'res')
          const endCheckTime = new Date().getTime()
          // 批改一份的用时
          const correctTime = endCheckTime - this.correctTime
          // 如果有下一份，批改下一份时使用
          this.correctTime = endCheckTime
          // 批改日志
          correctLogger.submitCorrect({
            ...this.getLoggerData(),
            // 批改一份的用时(单位：秒)
            correctTime: parseInt(correctTime / 1000),
            // 是否有总评语
            isRemark: !!remark,
            // 是否有语音点评
            isAudio: !!audioUrl,
            // 批改结果类型
            teacherOperateType,
            // 批改结果类型名称
            operateTypeName,
            // 提醒家长表扬学生是否勾选
            isPraiseChecked: !!(!isSupervise && isRemind),
            // 提醒家长督促学生是否勾选
            isSuperviseChecked: !!(isSupervise && isRemind)
          })
          this.visible = false
          this.confirmLoading = false
          if (this.buttonType == 2) {
            this.$router.go(-1)
          } else {
            this.userId = res.userId
            this.studentName = res.userName
            this.linkTypeName = res.linkTypeName
            this.linkId = res.linkId
            this.linkType = res.linkType
            this.optTime = res.optTime
            this.imgArr = res.linkDetailList
            if (res.residueCount == 0) {
              this.buttonType = 2
            }
            if (res.linkDetailList) {
              this.resetData()
              this.setImage(this.imgArr[this.index - 1].path, true)
            }
          }
        })
        .catch(error => {
          // 310000000: "批改错误"
          // 31001:"发送失败，该小组不在您名下"
          // 31002: "发送失败，课程被修改"
          // 31003:"发送失败，学员已不在组内，即将打开下一份"
          // 31004: "无待批改内容"
          // 31005: "发送失败，学员已不在组内"
          // 31006:"发送失败，学生已经提交最新自评订正，即将自动打开"
          switch (error.errorCode) {
            // 提示消失后，返回批改详情页
            case 310000000: // 批改错误，预料不到的异常情况
            case 31004: // 无待批改内容
            case 31005: // 发送失败，学员已不在组内
              this.clearWarnTimer()
              this.warnTimeOutTimer = setTimeout(() => {
                this.clearCheck()
                this.goRouter('checkDetailsPage', this.queryParams)
              }, this.warnSpeed)
              return false
            // 提示消失后，返回上课与批改主页面
            case 31001: // 发送失败，该小组不在您名下
            case 31002: // 发送失败，课程被修改
              this.clearWarnTimer()
              this.warnTimeOutTimer = setTimeout(() => {
                this.clearCheck()
                this.goRouter('classList')
              }, this.warnSpeed)
              return false
            // 自动打开最新
            case 31003: // 发送失败，学员已不在组内，即将打开下一份（其他学生）
              this.initCheckTool({ userId: -1 }, true)
              return false
            case 31006: // 发送失败，学生已经提交最新自评订正，即将自动打开（当前学生）
              this.initCheckTool({ userId: this.userId }, true)
              return false
            default:
              this.clearCheck()
              return false
          }
        })
    },
    clearWarnTimer() {
      this.warnTimeOutTimer && clearTimeout(this.warnTimeOutTimer)
    },
    /**
     * 关闭批改页面
     */
    clearCheck() {
      this.visible = false
      this.confirmLoading = false
    },
    resetData() {
      this.$refs.textarea.setValue('')
      this.tempData = new Map()
      this.imgData = new Map()
      this.teacherOperateType = 0
      this.countLength = 0
      this.updateDisable = true
      this.isRemind = 0
      this.remark = ''
      this.index = 1
      this.angle = 0
      // 重置录音
      this.$refs.audioRecord.resetRecord()
    },
    goRouter(path, query) {
      this.$router.push({
        path,
        query
      })
    },
    initCanvas() {
      this.canvas = new fabric.Canvas('canvas', {
        preserveObjectStacking: true,
        isDrawingMode: false,
        backgroundColor: '#f2f7fe'
      })
      fabric.Object.prototype.transparentCorners = false
      fabric.Object.prototype.cornerColor = '#bccbfb'
      fabric.Object.prototype.cornerStyle = 'circle'
      this.setImage(this.imgArr[this.index - 1].path, true)
      this.handleDelbutton()
      this.canvas.on('mouse:down', e => {
        if (!this.canvas.getActiveObject() || (this.canvas.getActiveObject() && this.canvas.getActiveObject().lockMovementX)) {
          this.panning = true
          this.canvas.selection = false
        }
      })

      this.canvas.on('mouse:up', e => {
        if (!this.canvas.getActiveObject() || (this.canvas.getActiveObject() && this.canvas.getActiveObject().lockMovementX)) {
          this.panning = false
          this.canvas.selection = true
        }
      })
    },
    setupBrush(brushName, opt) {
      this.canvas.freeDrawingBrush = new fabric[brushName](this.canvas, opt || {})
    },
    setImage(img, init) {
      const zoom = init ? 1 : this.canvas.getZoom()
      fabric.Image.fromURL(
        img,
        oImg => {
          const { width, height } = this.setCanvasImg(oImg)
          console.log(width, height, 'width, height>> ')
          oImg.set({
            left: 0,
            top: 0,
            lockMovementX: true,
            lockMovementY: true,
            hasControls: false
          })
          this.img = oImg
          this.canvas.add(oImg)
          if (this.angle == 0 && zoom == 1) {
            this.canvas.setWidth(oImg.width)
            this.canvas.setHeight(oImg.height)
            this.originWidth = oImg.width
            this.originHeight = oImg.height
            this.handlelayout(oImg.width, oImg.height)
          } else {
            if (this.angle / 90 % 2 == 0) {
              this.canvas.setWidth(oImg.width * zoom)
              this.canvas.setHeight(oImg.height * zoom)
            } else {
              this.canvas.setWidth(oImg.height * zoom)
              this.canvas.setHeight(oImg.width * zoom)
            }
            this.handleActiveObjectPosition(this.img)
            this.canvas.setZoom(zoom)
          }
          if (init) {
            this.canvas.setZoom(zoom * width / oImg.width)
            this.canvas.setWidth(width)
            this.canvas.setHeight(height)
            this.handlelayout(width, height)
          }
        },
        { crossOrigin: 'anonymous' }
      )
    },
    setCanvasImg(img) {
      const obj = {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      }
      if (img.width > img.height) {
        if (img.width > this.maxWidth) {
          obj.width = this.maxWidth
          obj.height = (img.height / img.width) * obj.width
        } else {
          obj.width = img.width
          obj.height = img.height
        }
      } else {
        if (img.height > this.maxHeight) {
          obj.height = this.maxHeight
          obj.width = (img.width / img.height) * obj.height
        } else {
          obj.width = img.width
          obj.height = img.height
        }
      }
      return obj
    },
    handleDelbutton() {
      const deleteImg = document.createElement('img')
      deleteImg.src = this.deleteIcon
      const _this = this
      function renderIcon(icon) {
        return function renderIcon(ctx, left, top, fabricObject) {
          if (!(_this.canvas.getActiveObject() && _this.canvas.getActiveObject().lockMovementX)) {
            const size = this.cornerSize
            ctx.save()
            ctx.translate(left, top)
            ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle))
            ctx.drawImage(icon, -size / 2, -size / 2, size, size)
            ctx.restore()
          }
        }
      }
      function deleteObject(eventData, transform) {
        const { target } = transform
        const { canvas } = target
        canvas.remove(target)
        canvas.renderAll()
      }
      fabric.Object.prototype.controls.deleteControl = new fabric.Control({
        x: 0.5,
        y: -0.5,
        offsetY: -16,
        offsetX: 16,
        cursorStyle: 'pointer',
        mouseUpHandler: deleteObject,
        render: renderIcon(deleteImg),
        cornerSize: 24
      })
    },
    setSealTool(brushDataUrl) {
      this.canvas.isDrawingMode = true
      const { originWidth, originHeight } = this
      const maxLength = originWidth > originHeight ? originWidth : originHeight
      // 在 src/static/js/fabric-brush.min.js 中配置的
      // _baseWidth 是 300，现在图片是 450 所以 width = 450-300
      this.setupBrush('SealTool', {
        color: this.brushColor,
        brushDataUrl,
        width: 450 - 300,
        // 根据需要批改的图片的尺寸设置缩放
        scale: (maxLength / 450) / (928 / 78)
      })
    },
    handleRight() {
      // 埋点
      correctLogger.rightIcon(this.getLoggerData())
      this.setSealTool(this.RightBrushDataUrl)
    },
    handleWrong() {
      // 埋点
      correctLogger.wrongIcon(this.getLoggerData())
      this.setSealTool(this.WrongBrushDataUrl)
    },
    handleModify() {
      this.canvas.isDrawingMode = false
      const items = this.canvas.getObjects()
      console.log(items)
      this.canvas.setActiveObject(items[0])
    },
    async handlePrev() {
      const curCanvasData = this.canvas.toJSON(['lockMovementX', 'lockMovementY'])
      const oldCanvasData = this.tempData.get(this.index)
      const bol = this.isNoChanged(curCanvasData, oldCanvasData)
      if (!bol) {
        this.tempData.set(this.index, curCanvasData)
        await this.handleSave(this.index, true)
      }
      this.canvas.isDrawingMode = false
      this.angle = 0
      if (this.index > 1) {
        this.index--
      }
      const lastState = this.tempData.get(this.index) || ''
      this.canvas.loadFromJSON(lastState, () => {
        this.setCanvasImg(lastState.objects[0])
        this.canvas.renderAll()
        const items = this.canvas.getObjects()
        this.img = items[0]
      })
    },
    async handleNext() {
      this.spinning = true
      this.nextbtnStatus = true
      this.canvas.isDrawingMode = false
      if (this.index < this.imgArr.length + 1) {
        this.index++
      }
      const curCanvasData = this.canvas.toJSON(['lockMovementX', 'lockMovementY'])
      const oldCanvasData = this.tempData.get(this.index - 1)
      const nextData = this.tempData.get(this.index)
      const bol = this.isNoChanged(curCanvasData, oldCanvasData)
      if (!bol) {
        this.tempData.set(this.index - 1, curCanvasData)
        await this.handleSave(this.index - 1)
      }
      if (nextData) {
        this.canvas.loadFromJSON(nextData, () => {
          this.setCanvasImg(nextData.objects[0])
          this.canvas.renderAll()
          const items = this.canvas.getObjects()
          this.img = items[0]
        })
      } else {
        this.canvas.clear()
        this.angle = 0
        this.canvas.setZoom(1)
        this.setImage(this.imgArr[this.index - 1].path, true)
      }
      this.spinning = false
      this.nextbtnStatus = false
    },
    isNoChanged(source, comparison) {
      if (!source || !comparison) {
        return false
      }
      const _source = JSON.stringify(source)
      const _comparison = JSON.stringify({ ...source, ...comparison })
      return _source === _comparison
    },
    handlexRotate() {
      // 埋点
      correctLogger.rotate(this.getLoggerData())
      this.angle += 90
      this.canvas.setActiveObject(this.img)
      const img = this.canvas.getActiveObject()
      const { width, height } = this.canvas

      this.canvas.setWidth(height)
      this.canvas.setHeight(width)
      this.handleActiveObjectPosition(img)
    },
    handleActiveObjectPosition(obj) {
      obj.rotate(this.angle)
      const angleNum = this.angle % 360
      let left = 0
      let top = 0
      switch (angleNum) {
        case 90:
          left = obj.height
          break
        case 180:
          left = obj.width
          top = obj.height
          break
        case 270 :
          top = obj.width
          break
      }
      obj.set({
        left,
        top
      })
      this.canvas.requestRenderAll()
    },
    base64ToBlob(urlData) {
      const arr = urlData.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = window.atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    async handleUploadImg(file, bol) {
      return this.$service.correction
        .getUploadToken()
        .then(res => {
          const { token, businessKey } = res
          return new Promise(resolve => {
            window.uploadFile({
              authorization: token,
              businessKey,
              file,
              isProduction: process.env.NODE_ENV == 'production',
              progress: data => {
                // console.log("progress", data);
              },
              result: body => {
                if (body.status === 1) {
                  const obj = {}
                  const index = this.imgArr.length > 1 && !bol ? this.index - 2 : this.index - 1
                  obj.path = body.data.url
                  obj.pathNum = this.imgArr[index].pathNum
                  const imgIndex = !bol ? this.index - 1 : this.index
                  this.imgData.set(imgIndex, obj)
                  console.log(body.data.url, this.imgData)
                } else {
                  // console.log('上传失败，请重新上传！')
                  message.error('上传图片失败')
                }
                resolve(this.imgData)
              }
            })
          })
        })
        .catch(() => {})
    },
    /**
     * index
     * bol：画布是否保存，true 保存，fase：不保存
     */
    async handleSave(index, bol) {
      const { canvas } = this
      // 保存画布当前信息
      const oldWidth = canvas.width
      const oldHeight = canvas.height
      const oldZoom = canvas.getZoom()
      // 将画布恢复到初始状态，保存图片的时候需要跟图片原始大小一样
      if (this.angle / 90 % 2 == 0) {
        this.canvas.setWidth(this.originWidth)
        this.canvas.setHeight(this.originHeight)
      } else {
        this.canvas.setWidth(this.originHeight)
        this.canvas.setHeight(this.originWidth)
      }
      console.log('>>>>oldZoom', oldZoom)
      this.canvas.setZoom(1)
      this.canvas.absolutePan({ x: 0, y: 0 })
      const dataURL = this.canvas.toDataURL('image/png')
      const blob = this.base64ToBlob(dataURL)
      this.form.set('file' + index, blob, Date.parse(new Date()) + '.png')
      await this.handleUploadImg(this.form.get('file' + index), bol)
      // 将画布还原回原来的状态
      this.canvas.setWidth(oldWidth)
      this.canvas.setHeight(oldHeight)
      this.canvas.setZoom(oldZoom)
    },
    confirmClear() {
      // 埋点
      correctLogger.clearCanvas(this.getLoggerData())
      this.canvas.clear()
      this.setImage(this.imgArr[this.index - 1].path)
    },
    handleTextarea(e) {
      this.countLength = e.target.textLength
      this.totalLength = e.target.maxLength
      this.remark = e.target.value
    },
    handleAnswerResult({ key }) {
      this.updateDisable = false
      this.teacherOperateType = key
    },
    // handleSendResult() {
    //   this.ModalText = this.teacherOperateType === '4' ? '提醒家长督促学生，家长端将收到提醒' : '提醒家长表扬学生，家长端将收到提醒'
    //   this.visible = true
    // },
    // handleCancel(e) {
    //   this.visible = false
    // },
    onChange(e) {
      const { checked } = e.target
      this.isRemind = checked ? 1 : 2
    },
    handlelayout(cWidth, cHeight) {
      const canvasbox = this.$refs.canvasbox
      const boundRect = canvasbox.getBoundingClientRect()
      if (boundRect.width > cWidth) {
        canvasbox.style.alignItems = 'center'
      } else {
        canvasbox.style.alignItems = 'inherit'
      }
      if (boundRect.height > cHeight) {
        canvasbox.style.alignItems = 'center'
      } else {
        canvasbox.style.alignItems = 'inherit'
      }
    },
    zoomIt(factor) {
      const cWidth = this.canvas.width
      const cHeight = this.canvas.height
      const zoom = this.canvas.getZoom()
      this.canvas.setWidth(cWidth * factor)
      this.canvas.setHeight(cHeight * factor)
      this.canvas.setZoom(zoom * factor)
      this.handlelayout(cWidth, cHeight)
    },
    zoomOut() {
      // 埋点
      correctLogger.zoomOut(this.getLoggerData())
      this.zoomIt(1.1)
    },
    zoomIn() {
      // 埋点
      correctLogger.zoomIn(this.getLoggerData())
      this.zoomIt(0.9)
    },
    formatData(arr) {
      const newArr = []
      arr = [...arr]
      for (let i = 0; i < arr.length; i++) {
        newArr.push(arr[i][1])
      }
      return newArr
    },
    /**
     * 查看答案
     */
    showAnswer() {
      // 埋点
      correctLogger.answerBtn(this.getLoggerData())
      const { isWorkword, isFirstExamWord } = this
      if (isWorkword) {
        this.$refs.answerModal.show()
      }
      if (isFirstExamWord) {
        this.$refs.answerModal.show(true)
        // this.$refs.picAnswer.showAnswer()
      }
    },
    // 埋点公共参数
    getLoggerData() {
      const { userId, query, linkTypeName } = this
      const { classTypeId, lessonId, groupId, linkType } = query
      return {
        groupId: Number(groupId),
        lessonId: Number(lessonId),
        courseId: Number(classTypeId),
        studentUserId: Number(userId),
        linkTypeName,
        linkType: Number(linkType)
      }
    },
    // 开始录音按钮
    startRecord() {
      // 埋点
    },
    getOperateName() {
      const { teacherOperateType, resultArr } = this
      const res = resultArr.filter(item => item.key === teacherOperateType)
      if (res.length) {
        return res[0].name
      }
      return ''
    }
  },
  filters: {
    formatDate(date) {
      if (!date || date == null) return null
      date = new Date(date)
      let fmt = 'yyyy/MM/dd hh:mm'
      const obj = {
        'y+': date.getFullYear(),
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes()
      }
      for (var k in obj) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 4 ? obj[k] : ('00' + obj[k]).substring(('' + obj[k]).length))
        }
      }
      return fmt
    }
  }
}
</script>
<style lang="less" scoped>
body {
  -webkit-user-select: none;
}
.check-container {
  width: 100%;
  height: calc(100vh - 120px);
  overflow: hidden;
  background: #fff;
  :deep(.ant-page-header) {
    padding: 5px;
    background: #fff;
    box-shadow: inset 0px -1px 0px #ebedf0;
    .ant-page-header-heading-title{
      color: #303858;
    }
  }
  :deep(.ant-layout) {
    height: 100%;
    background: #fff;
  }
  .canvas-wrap {
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      :deep(.ant-spin-nested-loading) {
        flex: 1;
        overflow: hidden;
      }
      :deep(.ant-spin-container) {
        height: 100%;
        position: relative;
      }
      .page-btn {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background: rgba(48, 56, 88, 0.5) !important;
        border: none !important;
        color: #fff !important;
        font-size: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        fill: #fff;
        &[disabled] {
          background: rgba(48, 56, 88, 0.3) !important;
          color: #98A2B2 !important;
          fill: #98A2B2;
        }
      }
      .page-prev {
        left: 20px;
      }
      .page-next {
        right: 20px;
      }
      .canvasbox {
        display: flex;
        align-items: center;
        // height: calc(100vh - 218px);
        height: 100%;
        position: relative;
        overflow: auto;
        background: #f2f7fe;
        &::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 6px rgba(172, 171, 171, 0.3);
          background-color: #F5F5F5;
        }

        &::-webkit-scrollbar {
          width: 9px;
          height: 9px;
          background-color: #F5F5F5;
        }

        &::-webkit-scrollbar-thumb{
          background-color: #b1b1b1;
        }
      }
      :deep(.canvas-container) {
        margin: 0 auto;
      }
  }
  .ant-layout-sider {
    padding: 20px 20px 15px;
    background: #fff;
    border-left: 1px solid #ebedf0;
    position: relative;
  }
  .operate-page {
    margin: 0 20px 15px 0;
    border-left: 1px solid #EBEDF0;
    padding-left: 8px;
    color: #3262FD;
  }
  // .operate-right-top {
  //   button.ant-btn.ant-btn-primary {
  //     color: #FFFFFF;
  //   }
  //   button.ant-btn.ant-btn-primary.actived {
  //     border-color: #2357FF;
  //     background-color: #2357FF;
  //   }
  // }
  .info {
    font-size: 14px;
    color: #505873;
    // height: calc(100vh - 172px);
    height: 100%;
    padding: 0;
    :deep(.ant-layout-sider-children) {
      padding-bottom: 64px;
      position: relative;
    }
    .operate-right-top {
      overflow-x: hidden;
      overflow-y: auto;
      height: 100%;
      padding: 20px;
    }
    .send-stu-btn {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
    }
    .ant-row-flex {
      margin-bottom: 20px;
      &.mb {
        margin-bottom: 6px;
      }
    }
    .ant-col-6 {
      margin-right: 16px;
    }
    .right-top {
      display: flex;
      align-items: center;
      color: #98A2B2;
      margin-bottom: 8px;
    }
    .username {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 90px;
      font-size: 18px;
      font-weight: 700;
      display: inline-block;
      color: #505873;
    }
    .timec {
      color: #505873;
      margin-bottom: 8px;
    }
    .step {
      color: #505873;
      margin-bottom: 21px;
    }
    .strong {
      font-weight: bold;
    }
    .comment {
      margin-bottom: 8px;
    }
    .audio-wrap {
      border: 1px solid #EBEDF0;
      border-left: none;
      border-right: none;
      margin: 0 -22px 20px -22px;
      padding: 20px 22px 0 22px;
    }
    .audio-title {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 9px;
    }
    .audio-tip {
      color: #98A2B2;
      font-weight: normal;
      font-size: 12px;
      margin-left: 8px;
      display: inline-flex;
      align-items: center;
      .tip-icon {
        margin-right: 4px;
      }
    }
    .txarea {
      position: relative;
      .ant-input {
        color: #505873;
        margin-top: 5px;
        border-radius: 6px;
        height: 104px;
      }
      .count {
        position: absolute;
        right: 14px;
        bottom: 6px;
        color: #98a2b2;
        font-size: 12px;
      }
    }
    .required {
      color: #f00;
      vertical-align: middle;
      font-weight: normal;
      margin-left: -6px;
    }
    .btnbox {
      button {
        width: 98px;
      }
      :deep(.ant-btn-primary) {
        background-color: #fff;
        border-color: #2357FF;
        color: #2357FF;
        &:hover {
          background-color: #EBF0FF;
        }
        &.actived {
          background-color: #2357FF;
          border-color: #2357FF;
          color: #fff;
        }
      }

      p {
        font-size: 12px;
        em {
          color: #505873;
        }
      }
    }
    .pagebtn {
      display: flex;
      justify-content: flex-end;
      width: 100%;
      right: 0;
      position: absolute;
      bottom: 16px;
      :deep(button) {
        margin-right: 8px;
      }
    }
    .check-btn {
      margin-left: 10px;
      margin-right: 12px;
    }
  }
}
.operatebox {
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  box-sizing: border-box;
  padding: 0 20px;
  ul {
    margin: 0;
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    li {
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .line {
    display: block;
    height: 24px;
    width: 1px;
    background: #EBEDF0;
    margin: 0 16px 0 20px;
  }
  .operate-tool {
    li {
      display: flex;
      align-items: center;
      &.edit-tool {
        margin-right: 24px;
      }
      &:last-child {
        margin-right: 0;
      }
    }
    .operate-icon {
      display: inline-block;
      width: 36px;
      height: 36px;
      background: center no-repeat;
      background-size: 100% auto;
      margin: 0 16px;
    }
  }
  .operate-tool-right {
    li {
      margin-right: 16px;
      &.line-wrap {
        margin-right: 8px;
      }
      .line {
        margin: 0;
      }
      .page-num {
        color: #505873;
        font-weight: 700;
        font-size: 14px;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .icon-comment {
    font-size: 36px;
    color: #fd1b1b;
    line-height: 36px;
  }
  .icon-tool {
    color: #70788C;
    font-size: 24px;
  }
  .icon-modify {
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAAG1BMVEUAAABweI1weIdweItwd41weIpwd4xxeYxweIxNfFlLAAAACHRSTlMA3yBw72DvX/Dr/fwAAABhSURBVCjPYxhJgN2jAwgYGJSRBRk7wIJMEgZIghwNYEqxUQFdEKhQiAFdEKEQIYhQiBBEKEQIghUCaRRBsEJ0QbBCDEFmoEJM7UZgGt12KguydUCBAJIgqwRErCWAYQQBAHZZHsPZv+cwAAAAAElFTkSuQmCC');
    background-size: 100% auto;
  }
  .icon-clean {
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAoBAMAAACREs5gAAAAGFBMVEUAAABweItwcIhweIxwd4xwd4tweIpweIy/vQXAAAAAB3RSTlMAgBC/r3Bg3ow1PQAAAEpJREFUKM9jGLmAsby8kGjRQkaiRJnMy4H6GcuBwAkhylYOFy1F1o1gERJlLYeDMiTb3OGiRijOgtNki0Ig+aKsyM7FdLARwwgFAJLdKjh3kbvFAAAAAElFTkSuQmCC');
    background-size: 100% auto;
  }
  .icon-rotate {
    margin-right: 18px;
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAoCAMAAABU4iNhAAAAPFBMVEUAAABweIdweI1wcIFwd41weIxweItweItweItweI1wd4xweItwd4twd4pweYxweYxwd4xwd4xweY1weIyuf9pvAAAAE3RSTlMAIN8Q779+YECfkKBQMO/Pz7CvuqOoDwAAAL9JREFUOMvtUkkOxDAIC4TsmW7+/19HaVoph6HVHCvVF0CyAFs2L56HmGeBzJlueHbDiXTJ/TAkR2tsLABfUInh6OwdJgpVYTLKMBUAytoAtsMBB8zqyrCrCr52IrIiB3w829VQKPE3s2JtJYE9w5kLePhWBGQI039MazTpqRXXrvd2RVUUTYOibsZHcyl2aT7Yw1/1UR4/s81fBQvSMCWwnhAZE3IXJqQ9dVnATY5OLTix3aWeshPIkqN58Th8AZb1CJYvng+mAAAAAElFTkSuQmCC');
    background-size: 100% auto;
  }
  .icon-zoomin {
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAoCAMAAABU4iNhAAAAPFBMVEUAAABweItweItweItwd41weIxweIxweIhwcIRweIxweI1wd4tweY1weIxwd4txd4xwdotwd4pwd4xweIyfywUcAAAAE3RSTlMAgEBg77+gIBDv33CPz7BvUDCvlLiRTgAAAKtJREFUOMvt0ksOwyAMRVEM5p9v3/732obSlImhUkeRcick0pmAre4uVyDLYJv9CK6MGvWhA6wOKmgHuB6cwLp+6oRJhgbsD0QH3yO0KGfk4yDQ+7AS9EiqkSHCC3LD0krlYARZBD6V/7+lKU/4FQ9s4o1iaGWCOFILauSKWUlpxP18ec8wvWmmc5qMZbAhrmyIxSvTo4QaZzOgPpdNpqBUpeMK1b9Sp+6u1BMDsAiu4ifuugAAAABJRU5ErkJggg==');
    background-size: 100% auto;
  }
  .icon-zoomout {
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAoCAMAAABU4iNhAAAAPFBMVEUAAABweItweItweItwd41weIxweIxweIhwcIRweIxweI1wd4tweY1weIxwd4txd4xwdotwd4pwd4xweIyfywUcAAAAE3RSTlMAgGBA77+gIBDv33CPz7BvUDCvrSTYyQAAAKZJREFUOMvtktkKAyEMRdXEfdbe///XtmI7C0QLfRqY82TgQMxN1M3lCNoy2GbfE2dGRbdFB1gKKpADXEscwFSflDDIogFv31sjSDRH5F2lYSXRIx1SiJACWDCdxjOCqd/J4EOp/zbNKcIHFnGiGPZ1grhSe2g3Y1QShLhuHRimtc303SZj6lyIKxdi8cK0VI0KZ9NRfS6XrINSVe1TVPpVdermSjwBNrIIJg0Il1oAAAAASUVORK5CYII=');
    background-size: 100% auto;
  }
}
.operate-center {
  flex: 1;
  display: flex;
  .center-left {
    flex: 4;
  }
  .center-right {
    flex: 1;
  }
}
.operate-right {
  display: flex;
}
// 批改结果
.operate-result {
  display: flex;
  justify-content: space-between;
  margin-top: 9px;
  :deep(.ant-btn) {
    i {
      letter-spacing: normal !important;
      margin-right: 0 !important;
    };
  }
}
.result-send-checkbox {
    padding-top: 9px;
  }
.check-group-name {
  padding: 0 !important;
  :deep(.ant-page-header-heading) {
    display: flex;
    height: 64px;
    align-items: center;
  }
  :deep(.ant-page-header-back) {
    padding: 0 18px 0 26px;
    margin: 0;
  }
  :deep(.ant-page-header-heading-title) {
    flex: 1;
    font-size: 14px;
    font-weight: normal;
    display: inline-flex;
    overflow: hidden;
    justify-content: space-between;
    padding-right: 24px;
    .title-h1 {
      font-size: 16px;
      font-weight: 700;
    }
    .title-h2 {
      color: #505873;
      max-width: 250px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .title-left, .title-right {
      span {
        display: inline-block;
        padding: 0 16px;
        position: relative;
        &:before {
          position: absolute;
          content: "";
          width: 1px;
          height: 16px;
          background: #EBEDF0;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
        &:first-child {
          padding-left: 0;
          &:before {
            width: 0;
          }
        }
        &:last-child {
          padding-right: 0;
        }
      }
    }
    .title-left {
      flex: 1;
      display: inline-flex;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      align-items: center;
      color: #505873;
      span {
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        // &:last-child {
        //   flex: 1;
        //   overflow: hidden;
        //   text-overflow:ellipsis;
        //   white-space: nowrap;
        // }
      }
      .link-type {
        display: inline-block;
        height: 24px;
        padding: 0 6px;

        /* 插画/Draw_1 */

        background: #E9F5FF;
        border-radius: 4px;
        font-size: 12px;
        color: #1E96FE;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: -12px;
        margin-right: 16px;
      }
    }
    .title-right {
      word-break: keep-all;
      color: #98A2B2;
      min-width: 380px;
      display: flex;
      align-items: center;
      justify-content:flex-end;
      .strong {
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
  }
}

</style>
